import Section from "../Section"
import { support } from "../utils";
import gsap from "gsap";

class AboutShape extends Section {
  constructor(opts) {
    super(opts)

    if (support.touch) return

    this.DOM = this.getDOM()
    this.tl = this.createTimeline()
  }

  getDOM() {
    return {
      shape: document.querySelector(".yellow-shape--three")
    }
  }

  createTimeline() {
    const tl = new gsap.timeline({ paused: true })

    tl.fromTo(this.DOM.shape, { y: "-150px", rotation: "60deg" }, { y: "0px", rotation: 0, force3D: true, ease: "Linear.easeNone" })

    tl.progress(1)

    return tl
  }

  run(opts) {
    super.run(opts)
    this.tl.progress(this.data.progress)
  }
}

export default AboutShape